import { action, computed, makeObservable, observable } from 'mobx';
import * as utils from '../../helpers/utils';

class Channel {
  _id;

  @observable IsPublic;

  @observable ChannelName;

  @observable ChannelDescription;

  @observable ChannelType; // ref ChannelType

  @observable Contacts; // ref Contact

  @observable IsDeleted;

  @observable CustomerPhoneNumber; // ref PhoneNumber

  @observable LastMessage;

  @observable ChannelStateType;

  @observable UsersTyping;

  @observable IsWebChatTransferredToSMS;

  constructor(incObject, store) {
    makeObservable(this);

    this._id = incObject._id ? incObject._id : utils.generateGuid();
    this.IsPublic = incObject.IsPublic || false;
    this.ChannelName = incObject.ChannelName || null;
    this.ChannelDescription = incObject.ChannelDescription || null;
    this.ChannelType = store.channelTypeStore.UpsertAndGet(incObject.ChannelType) || null;
    this.Contacts = incObject.Contacts ? store.contactStore.UpsertAndGet(incObject.Contacts) : [];
    this.IsDeleted = incObject.IsDeleted || false;
    this.CustomerPhoneNumber =
      store.phoneNumberStore.UpsertAndGet(incObject.CustomerPhoneNumber) || null;
    this.LastMessage = incObject.LastMessage || null;
    this.ChannelStateType = incObject.ChannelStateType || null;
    this.UsersTyping = incObject.UsersTyping ? incObject.UsersTyping : [];
    this.IsWebChatTransferredToSMS = incObject.IsWebChatTransferredToSMS || false;
  }

  @computed get getCustomer() {
    return this.Contacts?.find(
      (c) => c.ContactType.TypeId === utils.ContactTypeEnum.Customer.TypeId && !c.IsDeleted
    );
  }

  /* eslint-disable */
  @action static UpdateObject(incObject, oldObject, rootStore) {
    if (incObject.IsDeleted) {
      rootStore.channelStore.channels = rootStore.channelStore.channels.filter(
        (f) => f._id !== incObject._id
      );
      return null;
    }

    oldObject.IsPublic = incObject.IsPublic;
    oldObject.ChannelName = incObject.ChannelName;
    oldObject.ChannelDescription = incObject.ChannelDescription;
    oldObject.ChannelType = rootStore.channelTypeStore.UpsertAndGet(incObject.ChannelType);
    oldObject.CustomerPhoneNumber = rootStore.phoneNumberStore.UpsertAndGet(
      incObject.CustomerPhoneNumber
    );
    oldObject.Contacts = rootStore.contactStore.UpsertAndGet(incObject.Contacts);
    oldObject.IsDeleted = incObject.IsDeleted;
    oldObject.LastMessage = incObject.LastMessage;
    oldObject.ChannelStateType = incObject.ChannelStateType;
    oldObject.UsersTyping = incObject.UsersTyping;
    oldObject.IsWebChatTransferredToSMS = incObject.IsWebChatTransferredToSMS;

    return oldObject;
  }
  /* eslint-enable */
}

export default Channel;
